import { fromPairs, IdentifiableMap } from "../../collections";
import { makeImmutable } from "../../core";
/**
 * Part of a product instance
 * Has ProductType and modifierInstances
 */
export class ProductInstancePart {
    constructor(params) {
        this.productType = params.productType;
        this.modifierInstances = params.modifierInstances;
        makeImmutable(this);
    }
    static empty(productType) {
        return new ProductInstancePart({
            productType,
            modifierInstances: IdentifiableMap.empty(),
        });
    }
    eq(other) {
        return (this.productTypeId.eq(other.productTypeId) &&
            IdentifiableMap.eq("typeId", this.modifierInstances, other.modifierInstances));
    }
    isCartEquivalentTo(other) {
        return this.productTypeId.eq(other.productTypeId);
    }
    get productTypeId() {
        return this.productType.id;
    }
    get productCategoryId() {
        return this.productType.productCategoryId;
    }
    get weeklySchedule() {
        var _a, _b;
        return (_b = (_a = this.productType.schedule) === null || _a === void 0 ? void 0 : _a.schedule) !== null && _b !== void 0 ? _b : null;
    }
    get storageData() {
        return {
            productTypeId: this.productType.id.value,
            productConfig: {
                customParameterInstances: {},
                modifierInstances: fromPairs(this.modifierInstances.objects.map((mi) => [
                    mi.typeId.value,
                    mi.storageData,
                ])),
            },
        };
    }
}
